(function () {
  if (window.__txcGoogleAdsConversionsLoaded) return;
  window.__txcGoogleAdsConversionsLoaded = true;

  const GOOGLE_ADS_ID = 'AW-17701259862';
  const CONVERSIONS = {
    addToCart: 'AW-17701259862/kN6PCIzwnbkbENaUz_hB',
    beginCheckout: 'AW-17701259862/GvBoCI_wnbkbENaUz_hB',
  };

  const centsToAmount = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return undefined;
    return Math.max(amount / 100, 0);
  };

  const getCurrency = (fallback) => (
    fallback
    || window.Shopify?.currency?.active
    || window.Shopify?.Checkout?.currency
    || 'USD'
  );

  const conversion = (sendTo, params = {}) => {
    const payload = {
      send_to: sendTo,
      ...params,
    };

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', payload);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(['event', 'conversion', payload]);
  };

  const cartAddValue = (cartData) => {
    if (Array.isArray(cartData?.items)) {
      return cartData.items.reduce((total, item) => {
        const lineValue = Number.isFinite(Number(item.final_line_price))
          ? Number(item.final_line_price)
          : Number(item.price || 0) * Number(item.quantity || 1);
        return total + lineValue;
      }, 0);
    }

    if (Number.isFinite(Number(cartData?.final_line_price))) {
      return Number(cartData.final_line_price);
    }

    return Number(cartData?.price || 0) * Number(cartData?.quantity || 1);
  };

  const trackAddToCart = (cartData) => {
    const value = centsToAmount(cartAddValue(cartData));
    conversion(CONVERSIONS.addToCart, {
      value,
      currency: getCurrency(cartData?.currency),
      event_category: 'ecommerce',
      event_label: 'add_to_cart',
    });
  };

  const trackBeginCheckout = () => {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : null)
      .then((cart) => {
        const value = centsToAmount(cart?.total_price);
        conversion(CONVERSIONS.beginCheckout, {
          value,
          currency: getCurrency(cart?.currency),
          event_category: 'ecommerce',
          event_label: 'begin_checkout',
        });
      })
      .catch(() => {
        conversion(CONVERSIONS.beginCheckout, {
          currency: getCurrency(),
          event_category: 'ecommerce',
          event_label: 'begin_checkout',
        });
      });
  };

  const subscribeToCartUpdates = () => {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS?.cartUpdate) return false;

    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      trackAddToCart(event.cartData);
    });

    return true;
  };

  if (!subscribeToCartUpdates()) {
    document.addEventListener('DOMContentLoaded', subscribeToCartUpdates, { once: true });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';
    const submitter = event.submitter;
    const name = submitter?.getAttribute('name') || form.querySelector('[name="checkout"]')?.getAttribute('name');
    const isCheckout = name === 'checkout' || /\/cart(?:\/)?$/i.test(action);

    if (isCheckout && form.querySelector('[name="checkout"], button[name="checkout"]')) {
      trackBeginCheckout();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const checkoutControl = event.target.closest?.(
      'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
    );

    if (checkoutControl) {
      trackBeginCheckout();
    }
  }, true);

  window.txcGoogleAdsConversions = {
    tagId: GOOGLE_ADS_ID,
    conversions: CONVERSIONS,
    trackAddToCart,
    trackBeginCheckout,
    testAddToCart: () => conversion(CONVERSIONS.addToCart, {
      value: 0,
      currency: getCurrency(),
      event_category: 'ecommerce',
      event_label: 'test_add_to_cart',
    }),
    testBeginCheckout: () => conversion(CONVERSIONS.beginCheckout, {
      value: 0,
      currency: getCurrency(),
      event_category: 'ecommerce',
      event_label: 'test_begin_checkout',
    }),
  };
})();
